module.exports = __webpack_public_path__ + "static/media/dollar_coin_bronze.c9629f32.png";